import { Component, Injector, OnInit } from '@angular/core';
import { BaseResourceForm } from '../../shared/extends/base-resource-form';
import { comumService } from '../../shared/service/comum.service';
import { LocalStorageService } from '../../shared/service/localstorage/localstorage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators } from '@angular/forms';
import { ToastService } from '../../shared/service/toast.service';
import { ConferenciaAutenticidadeService } from '../../shared/service/conferencia-autenticidade.service';

@Component({
  selector: 'app-public-validacao-autenticidade',
  templateUrl: './public-validacao-autenticidade.component.html',
  styleUrl: './public-validacao-autenticidade.component.scss',
  standalone: false
})
export class PublicValidacaoAutenticidadeComponent
  extends BaseResourceForm
  implements OnInit {

  public captchaGenerate: string = '';
  public captchaToken: string = '';
  public itens: any = {};
  public resultado: any[] = [];

  public cols_validacao: any[] = [
    { field: 'emitente', header: 'EMITENTE' },
    { field: 'perfil', header: 'PERFIL' },
    { field: 'data_hora', header: 'DATA/HORA' }
  ];

  public codigo_verificador: string = '';
  public arquivoPdf: File | null = null;

  private readonly tamanhoMaximoPdfBytes = 20 * 1024 * 1024;

  constructor(
    public service: comumService,
    public localStorage: LocalStorageService,
    public override router: Router,
    injector: Injector,
    private message1: ToastService,
    private actRoute: ActivatedRoute,
    private conferenciaAutenticidadeService: ConferenciaAutenticidadeService,
  ) {
    super(injector);
    this.createForm();
    this.gerarCaptchaDoBackend();
  }

  ngOnInit(): void {
    this.actRoute.queryParams.subscribe((params: any) => {
      this.codigo_verificador = params['codigo_verificador'] || '';

      this.myForm.patchValue({
        codigo_verificacao: this.codigo_verificador
      });
    });
  }

  createForm(): void {
    this.myForm = this.formBuilder.group({
      codigo_verificacao: ['', Validators.required],
      arquivo_pdf: [null, Validators.required],
      captcha: ['', Validators.required]
    });
  }

  submit(): void {
    // Método exigido pela classe BaseResourceForm.
    // A validação deste componente é feita por submitBtnClick().
  }

  gerarCaptchaDoBackend(): void {
    this.conferenciaAutenticidadeService
      .gerarCaptcha()
      .then(({ token, desafio }) => {
        this.captchaToken = token;
        this.captchaGenerate = desafio;
        this.myForm.patchValue({ captcha: '' });
      })
      .catch(() => {
        this.message1.showError('Não foi possível carregar o captcha. Tente novamente.');
      });
  }

  refreshBtnClick(): void {
    this.gerarCaptchaDoBackend();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      this.arquivoPdf = null;
      this.myForm.patchValue({ arquivo_pdf: null });
      return;
    }

    const hasValidExtension = file.name.toLowerCase().endsWith('.pdf');
    const hasValidType = file.type === 'application/pdf';

    if (!hasValidExtension || !hasValidType) {
      this.arquivoPdf = null;
      this.myForm.patchValue({ arquivo_pdf: null });
      input.value = '';
      this.message1.showError('Formato de arquivo inválido. Carregue um arquivo .pdf.');
      return;
    }

    if (file.size > this.tamanhoMaximoPdfBytes) {
      this.arquivoPdf = null;
      this.myForm.patchValue({ arquivo_pdf: null });
      input.value = '';
      this.message1.showError('O arquivo PDF deve ter no máximo 20MB.');
      return;
    }

    this.arquivoPdf = file;
    this.myForm.patchValue({ arquivo_pdf: file });
  }

  submitBtnClick(): void {
    if (this.myForm.invalid) {
      this.myForm.markAllAsTouched();
      this.message1.showWarn('Preencha o código verificador, selecione o PDF e informe o captcha.');
      return;
    }

    this.validaDocumento();
  }

  validaDocumento(): void {
    if (!this.arquivoPdf) {
      this.message1.showWarn('Selecione o PDF para validação.');
      return;
    }

    const codigoVerificador = this.myForm.get('codigo_verificacao')?.value;
    const captchaResposta   = this.myForm.get('captcha')?.value;

    this.resultado = [];

    this.conferenciaAutenticidadeService
      .validarPdfPublico(
        this.arquivoPdf,
        codigoVerificador,
        this.captchaToken,
        captchaResposta
      )
      .then((response: any) => {
        if (response?.status === 'documento_alterado') {
          this.message1.showError('Nenhum registro encontrado para o código e arquivo informados.');
          this.gerarCaptchaDoBackend();
          return;
        }

        if (response) {
          this.resultado.push(response);
          return;
        }

        this.message1.showError('Nenhum registro encontrado para o código e arquivo informados.');
      })
      .catch((erro: any) => {
        const is422 = erro?.meta?.codigo === 422;
        const fallback = is422
          ? 'Captcha inválido. Tente novamente.'
          : 'Não foi possível validar a autenticidade do relatório. Tente novamente.';

        this.message1.showError(erro?.meta?.mensagem || fallback);

        if (is422) {
          this.gerarCaptchaDoBackend();
        }
      });
  }
}